import { registerPlugin } from '@capacitor/core';

export type BonoNativeMaintenancePlugin = {
  clearWebViewCache(): Promise<void>;
  installApk(options: { uri?: string; base64?: string; filename?: string }): Promise<void>;
  canInstallPackages(): Promise<{ allowed: boolean }>;
  openInstallPermissionSettings(): Promise<void>;
};

export const BonoNativeMaintenance = registerPlugin<BonoNativeMaintenancePlugin>('BonoNativeMaintenance', {
  web: () => import('./bonoNativeMaintenanceWebStub.ts').then((m) => m.default),
});
